import {
  ADD_COUPON,
  ADD_RECOMMENDED_COUPONS,
  ADD_FORM,
  BOARDING_STATIONS,
  BOOKING_REVIEW, CHANGE_SELECTED_COUPON,
  FETCH_TRAVELLERS,
  LOAD_TRAVELLERS, REMOVE_COUPON,
  SHOW_ERROR,
  SUBMIT_FORM,
  TOGGLE_INSURANCE,
  TOGGLE_PREFERENCE,
  UPDATE_BOARDING_STATION,
  UPDATE_RESERVATION_CHOICE,
  UPDATE_USER_DETAIL,
  SET_ADDRESS_LINE1,
  SET_ERROR_ADDL1,
  SET_ADDRESS_LINE2,
  SET_ERROR_ADDL2,
  SET_ADDRESS_LINE3,
  SET_ERROR_ADDL3,
  SET_PINCODE,
  SET_STATE,
  SET_CITY,
  SET_POST_OFFICE,
  SET_ERROR_PINNO,
  SET_ERROR_IRCTC_USER_ID,
  SET_POST_OFFICE_LIST,
  GET_ADDRESS_FROM_LS,
  ACTION_RAILOFY_RESPONSE,
  ACTION_SET_FREE_CANCELLATION,
  SAVE_RAILOFY_OPTIONS,
  ACTION_ON_SELECT_CNFM_GUARANTEE,
  ACTION_RAILOFY_ERROR,
  ACTION_RAILOFY_LOADING,
  ACTION_VALIDATING_COUPON,
  ACTION_SET_OR_RESET_LOGIN_MODAL,
  ACTION_SHOW_IRCTC_VERIFICATION_MODAL,
  SHOW_GSTIN_COMPONENT,
  GSTIN_STATE,
  GSTIN_USERCONSENT,
  GSTIN_STATE_ERROR,
  GSTIN_USERCONSENT_ERROR,
  UPDATE_TRIP_TAG_DETAILS,
  ACTION_ZCSHOW_ERROR,
  ACTION_FC_TG_FIRST_SELECTION,
  ACTION_ON_AVAIL_SUBSCRN,
  UPDATE_REVIEW_VERIFICATION_FLOW,
} from '../../../../constants/ActionTypes';
import { InsuranceStates } from '../../../../constants/InsuranceStates';

const INITIAL_STATE = {
  boardingStations: [],
  travellers: {},
  selectedTravellers: {},
  bkgCfg: {},
  options: {},
  selectedBoardingStation: {},
  selectedReservationChoice: {},
  viewAll: false,
  autoUpgradationSelected: false,
  confirmBookCheckbox: false,
  travelInsuranceOpted: InsuranceStates.FALSE,
  refundAndCanChecked: true,
  travellerExceeded: false,
  travellerBerth: false,
  name: '',
  email: '',
  primaryPax: {
    primaryTravellerId: '',
    primaryPaxEmail: '',
  },
  tripTagDetails: {},
  mobileNumber: '',
  bookingReviewResponse: {},
  showError: false,
  coupons: [],
  selectedCoupon: {},
  couponErrorMessage: '',
  captureAddress: false,
  addressError: false,
  travelAdvisoryDetails: {},
  freeCancellationSelected: 'error',
  freeCancellationData: {},
  postOfficeList: [],
  psgnDestinationAddress: {
    'address': '', // Mandatory
    'street': '', // address 2 // Optional
    'colony': '', // address 3. / optional
    'city': '', // mandatory
    'postOffice': '', // Mandtory
    'state': '', // mandatory
    'pinCode': '', // Pin is not a string. it is a number // manadtory
  },
  psgnDestErrorMsg: {
    'address': '', // Mandatory
    'street': '', // address 2 // Optional
    'colony': '', // address 3. / optional
    'pinCode': '', // Pin is not a string. it is a number // manadtory
  },
  psgnDestError: {
    'address': false, // Mandatory
    'street': false, // address 2 // Optional
    'colony': false, // address 3. / optional
    'pinCode': false, // Pin is not a string. it is a number // manadtory
  },
  railofy: {

  },
  validatingCoupon: false,
  showLoginModal : false,
  showIrctcVerificationModal: false,
  showGSTINcomponent: false,
  gstinBillingAddress: {
    state: '',
    userConsent: false,
    userConsentError: false,
    stateError: false,
  },
  availabilitySubscription: {
    isAvailSubscrnEnabled: false,
    showSubscriptionWidget: false,
    showToast: false,
    toastMessage: '',
  }
};

export default (state = INITIAL_STATE, action) => {
  
  switch (action.type) {
  case BOARDING_STATIONS: {
    let selectedId = 0;
    const {
      boardingStationsList,
      alternateAvailability,
      boardingStation,
      arrivalJourneyDate,
      depJourneyDate,
      confirmedOptions
    } = action.payload;
    if (alternateAvailability) {
      selectedId = boardingStationsList.findIndex((x) => x.stationCode === boardingStation.code);
      if(selectedId < 0){
        selectedId = 0;
      }
    }
    if(confirmedOptions){
      selectedId = boardingStationsList.findIndex((x) => x.stationCode === confirmedOptions?.boardingStation.code);
    }
    return {
      ...state,
      boardingStations: action.payload,
      selectedBoardingStation: (selectedId >= 0) ? boardingStationsList[selectedId] : boardingStation,
      arrivalJourneyDate,
      depJourneyDate,
    };
  }
  case UPDATE_BOARDING_STATION: {
    return {
      ...state,
      selectedBoardingStation: action.payload,
    };
  }
  case UPDATE_RESERVATION_CHOICE: {
    return {
      ...state,
      selectedReservationChoice: action.payload,
    };
  }
  case UPDATE_USER_DETAIL: {
    return { ...state, ...action.payload };
  }
  case UPDATE_TRIP_TAG_DETAILS: {
    return {
      ...state,
      tripTagDetails: {
        ...state.tripTagDetails,
        ...action.payload,
      }
    }
  }
  case FETCH_TRAVELLERS: {
    return { ...state, ...action.payload };
  }
  case LOAD_TRAVELLERS: {
    return { ...state, ...action.payload };
  }
  case TOGGLE_PREFERENCE: {
    return { ...state, ...action.payload };
  }
  case TOGGLE_INSURANCE: {
    return { ...state, travelInsuranceOpted: action.payload };
  }
  case SUBMIT_FORM: {
    const { id, data, selectedTravellers, travellerExceeded, travellerBerth } = action.payload;
    return {
      ...state,
      travellers: {
        ...state.travellers,
        [id]: { ...state.travellers[id], ...data },
      },
      selectedTravellers,
      travellerExceeded,
      travellerBerth,
    };
  }
  case ADD_FORM: {
    const { travellers, selectedTravellers, travellerExceeded, travellerBerth } = action.payload;
    return {
      ...state,
      travellers,
      selectedTravellers,
      travellerExceeded,
      travellerBerth,
    };
  }
  case BOOKING_REVIEW: {
    return { ...state, bookingReviewResponse: action.payload };
  }
  case SHOW_ERROR: {
    return { ...state, showError: action.payload };
  }
  case ACTION_VALIDATING_COUPON: {
    return {
      ...state,
      validatingCoupon: true,
    }
  }
  case ADD_COUPON: {
    const coupon = action.payload;
    let isPresent = false;
    if (coupon.errorDetails) {
      return { ...state, couponErrorMessage: coupon.errorDetails.errorMessage, validatingCoupon: false, };
    } else {
      isPresent = state.coupons.some( (item) => item.couponCode === coupon.couponCode);
      if (isPresent) {
        return { ...state, selectedCoupon: coupon, couponErrorMessage: '', validatingCoupon: false };
      }
      return { ...state, coupons: [ ...state.coupons, coupon ], selectedCoupon: coupon, couponErrorMessage: '', validatingCoupon: false, };
    }
  }
  case ADD_RECOMMENDED_COUPONS: {
    const coupon = action.payload;
    if (coupon && coupon.errorDetails) {
      return { ...state, couponErrorMessage: coupon.errorDetails.errorMessage, validatingCoupon: false };
    } else {
      return { ...state, coupons: [ ...state.coupons, ...coupon ], couponErrorMessage: '', validatingCoupon: false };
    }
  }
  case REMOVE_COUPON: {
    const couponToBeRemoved = action.payload;
    const remainingCoupons = state.coupons;
    return {
      ...state,
      coupons: remainingCoupons,
      selectedCoupon: state.selectedCoupon.couponCode === couponToBeRemoved.couponCode ? {} : state.selectedCoupon,
      couponErrorMessage: '',
      validatingCoupon: false
    };
  }
  case CHANGE_SELECTED_COUPON: {
    const coupon = action.payload;
    return { ...state, selectedCoupon: coupon, couponErrorMessage:'', validatingCoupon: false };
  }
  case SET_ADDRESS_LINE1: {
    return { ...state, psgnDestinationAddress: { ...state.psgnDestinationAddress, address: action.payload } };
  }
  case SET_ADDRESS_LINE2: {
    return { ...state, psgnDestinationAddress: { ...state.psgnDestinationAddress, street: action.payload } };
  }
  case SET_ADDRESS_LINE3: {
    return { ...state, psgnDestinationAddress: { ...state.psgnDestinationAddress, colony: action.payload } };
  }
  case SET_PINCODE: {
    return { ...state, psgnDestinationAddress: { ...state.psgnDestinationAddress, pinCode: action.payload } };
  }
  case SET_STATE: {
    return { ...state, psgnDestinationAddress: { ...state.psgnDestinationAddress, state: action.payload } };
  }
  case SET_CITY: {
    return { ...state, psgnDestinationAddress: { ...state.psgnDestinationAddress, city: action.payload } };
  }
  case SET_POST_OFFICE: {
    return { ...state, psgnDestinationAddress: { ...state.psgnDestinationAddress, postOffice: action.payload } };
  }
  case SET_ERROR_ADDL1: {
    return { ...state,
      psgnDestErrorMsg: { ...state.psgnDestErrorMsg, address: action.payload.errorMsg },
      psgnDestError: { ...state.psgnDestError, address: action.payload.error } };
  }
  case SET_ERROR_ADDL2: {
    return { ...state,
      psgnDestErrorMsg: { ...state.psgnDestErrorMsg, street: action.payload.errorMsg },
      psgnDestError: { ...state.psgnDestError, street: action.payload.error } };
  }
  case SET_ERROR_ADDL3: {
    return { ...state,
      psgnDestErrorMsg: { ...state.psgnDestErrorMsg, colony: action.payload.errorMsg },
      psgnDestError: { ...state.psgnDestError, colony: action.payload.error } };
  }
  case SET_ERROR_PINNO: {
    return { ...state,
      psgnDestErrorMsg: { ...state.psgnDestErrorMsg, pinCode: action.payload.errorMsg },
      psgnDestError: { ...state.psgnDestError, pinCode: action.payload.error } };
  }

  case SET_ERROR_IRCTC_USER_ID: {
    return {
      ...state,
      verifyUserIdError: action.payload.errorMsg,
    };
  }
  case SET_POST_OFFICE_LIST: {
    return {
      ...state,
      postOfficeList: action.payload,
    };
  }
  case GET_ADDRESS_FROM_LS: {
    const {
      psgnDestError,
      psgnDestErrorMsg,
      psgnDestinationAddress,
      postOfficeList,
    } = action.payload;
    return {
      ...state,
      psgnDestErrorMsg,
      psgnDestError,
      postOfficeList,
      psgnDestinationAddress,
    };
  }
  case ACTION_SET_FREE_CANCELLATION: {
    const { freeCancellationSelected, selectedIndex } = action.payload;
    return {
      ...state,
      railofy: {
        ...state.railofy,
        freeCancellationSelectedOption: selectedIndex,
        freeCancellationSelected,
      },
    };
  }

  case SAVE_RAILOFY_OPTIONS: {
    return {
      ...state,
      railofy: {
        ...state.railofy,
        railofyOption: action.payload,
      },
    };
  }

  case ACTION_RAILOFY_RESPONSE: {
    return {
      ...state,
      railofy: {
        ...state.railofy,
        railofyResponse: action.payload,
      },
    };
  }

  case ACTION_ON_SELECT_CNFM_GUARANTEE: {
    return {
      ...state,
      railofy: {
        ...state.railofy,
        railofySelectedOption: action.payload.selectedIndex,
        optedForRailofy: action.payload.isSelected,
      },
    };
  }

  case ACTION_RAILOFY_ERROR: {
    return {
      ...state,
      railofy: {
        ...state.railofy,
        showError: action.payload,
      },
    }
  }

  case ACTION_ZCSHOW_ERROR:{
    return {
      ...state,
      railofy: {
        ...state.railofy,
        showZCError: action.payload,
      },
    }
  }

  case ACTION_FC_TG_FIRST_SELECTION:{
    return {
      ...state,
      railofy: {
        ...state.railofy,
        fcTgFirstSelection: action.payload,
      }
    }
  }

  case ACTION_RAILOFY_LOADING: {
    return {
      ...state,
      railofy: {
        ...state.railofy,
        isLoading: action.payload.isLoading,
      },
    }
  }

  case ACTION_SET_OR_RESET_LOGIN_MODAL : {
      return {
        ...state,
        showLoginModal : action.payload
      }
  }
  case ACTION_SHOW_IRCTC_VERIFICATION_MODAL: {
    return {
      ...state,
      showIrctcVerificationModal: action.payload
    };
  }

  case SHOW_GSTIN_COMPONENT: {
    return { 
      ...state, 
      showGSTINcomponent: action.payload 
    };
  }

  case GSTIN_STATE: {
    const gstin_state = action.payload;
    return {
      ...state,
      gstinBillingAddress: {
        ...state.gstinBillingAddress,
        state: gstin_state,
      }
    }
  }

  case GSTIN_USERCONSENT: {
    const gstin_userconsent = action.payload;
    return {
      ...state,
      gstinBillingAddress: {
        ...state.gstinBillingAddress,
        userConsent: gstin_userconsent,
      }
    }
  }

  case GSTIN_STATE_ERROR: {
    const gstin_stateError = action.payload;
    return {
      ...state,
      gstinBillingAddress: {
        ...state.gstinBillingAddress,
        stateError: gstin_stateError,
      }
    }
  }

  case GSTIN_USERCONSENT_ERROR: {
    const gstin_userconsentError = action.payload;
    return {
      ...state,
      gstinBillingAddress: {
        ...state.gstinBillingAddress,
        userConsentError: gstin_userconsentError,
      }
    }
  }

  case ACTION_ON_AVAIL_SUBSCRN: {
    return {
      ...state,
      availabilitySubscription: {
        ...state.availabilitySubscription,
        ...action.data,
      }
    }
  }
  case UPDATE_REVIEW_VERIFICATION_FLOW: {
    return {
      ...state,
      bookingReviewResponse: {
        ...state.bookingReviewResponse,
        reviewVerificationFlow: action.payload
      }
    };
  }

  default:
    return state;
  }
};
